import React from "react";
import styled from "@emotion/styled";
import { Avatar, IconButton, Link as LinkButton } from "@material-ui/core";
import ArrowProfileIcon from "../../../icon/icons/arrow-profile-icon.component";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { Link } from "react-router-dom";
import { getProfile } from "../../../../features/user/store/user.store";
import { useSelector } from "react-redux";
import * as userStore from "../../../../features/user/store/user.store";

const Wrapper = styled(IconButton)`
  position: relative;
  display: block;
`;

const ItemWrapper = styled.span`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 12px;
  right: 9px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
`;

const ProfilePicture = styled(Avatar)`
  width: 54px;
  height: 54px;
  margin: 0;
`;

const MenuItemWrapper = styled(MenuItem)`
padding: 0;
`;

const MenuLink = styled(Link)`
  color: inherit;
  border: 3px solid transparent;
  text-decoration: none;
  padding: 6px 16px;
  display: inline-block;
  width: 100%;

  &:focus {
    outline: none;
    border: 3px solid #00CAFF;
    color: #000;
    background-color: #e0f5ff;
  }
`;
const MenuLinkButton = styled(LinkButton)`
color: inherit;
border: 3px solid transparent;
text-decoration: none;
padding: 6px 16px;
display: inline-block;
width: 100%;

&:focus {
  outline: none;
  border: 3px solid #00CAFF;
  color: #000;
  background-color: #e0f5ff;
}
`;

const ProfilePictureButton = () => {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const userProfile = useSelector(getProfile);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: React.MouseEvent<EventTarget>) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Tab") {
      event.preventDefault();
      anchorRef.current?.focus();
    }
    if (event.key === "Enter") {
     userStore.logout();
    }
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current && !open) {
      anchorRef.current!.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Wrapper
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        title={`${userProfile.firstName} ${userProfile.lastName}`}
      >
        <ProfilePicture src={(userProfile.profileImageUrl) ? userProfile.profileImageUrl : "/profile.png" } />
        <ItemWrapper>
          <ArrowProfileIcon />
        </ItemWrapper>
      </Wrapper>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition={true}
        disablePortal={true}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === "bottom" ? "center top" : "center bottom" }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow">
                  <MenuItem>
                    {userProfile.id ? `${userProfile.firstName} ${userProfile.lastName}` : "..."}
                  </MenuItem>
                  <MenuItemWrapper>
                    <MenuLink tabIndex={0} to={"/support"}>Support</MenuLink> 
                  </MenuItemWrapper>
                  <MenuItemWrapper>
                    <MenuLinkButton tabIndex={0} onClick={userStore.logout} color="inherit" onKeyDown={handleListKeyDown}>Logout</MenuLinkButton>
                  </MenuItemWrapper>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
export default ProfilePictureButton;
